import { Injectable } from "@angular/core";
import { ProfileModel, CartItemModel, CartModel, UserModel, LocationDetails } from '../models/profile.model';
import { Product } from '../models/company.model';

import { FirebaseAuthService } from '../pages/firebase-integration/firebase-auth.service';

@Injectable()
export class ProfileStorageService {
    private profile: ProfileModel;

    constructor(
        public fAuthService: FirebaseAuthService
    ) { }

    setProfile(profile: ProfileModel): void {
        this.profile = profile;
    }

    getProfile(): ProfileModel {
        if (this.profile) {
            if (this.profile.user.id == null || this.profile.user.id == "") {
                this.fAuthService.doLogout().then(() => { });
            }
            return this.profile;
        }

        return null;
    }

    getUser(): UserModel {
        if (this.profile) {
            if (this.profile.user.id == null || this.profile.user.id == "") {
                this.fAuthService.doLogout().then(() => { });
            }
            return this.profile.user;
        }

        return null;
    }

    setCart(cart: CartModel): void {
        this.profile.cart = cart;
    }

    getCart(): CartModel {
        if (this.profile) {
            if (this.profile.user.id == null || this.profile.user.id == "") {
                this.fAuthService.doLogout().then(() => { });
            }
            return this.profile.cart;
        }

        return null;
    }

    getLocationDetails(): LocationDetails {
        return this.profile.locationDetails;
    }

    handleUndefinedCart() {
        if (!this.profile.cart || !this.profile.cart.items)
            this.profile.cart = new CartModel();
    }

    providerCheck(product: Product, companyId: string) {

        
    }

    addProductTocart(product: Product, companyId: string, quantity: number) {
        this.handleUndefinedCart();

        if(companyId != this.profile.cart.companyId) {
            this.profile.cart = new CartModel();
            this.profile.cart.companyId = companyId;
        }

        this.profile.cart.currency = product.currency;

        let newProduct = new CartItemModel();

        newProduct.id = product.id;
        newProduct.image = product.image;
        newProduct.pricePerUnit = product.pricePerUnit;
        newProduct.purchaseQuantity = quantity;
        newProduct.title = product.title;

        this.checkCartForExistingItem(newProduct);

        this.updateCart();
    }

    checkCartForExistingItem(newProduct: CartItemModel) {
        let foundFlag: boolean = false;

        this.profile.cart.items.forEach(element => {
            if (element.id === newProduct.id) {
                element.purchaseQuantity = element.purchaseQuantity + newProduct.purchaseQuantity;
                foundFlag = true;
            }
        });

        if (!foundFlag) {
            this.profile.cart.items.push(newProduct);
        }
    }

    updateCart() {
        this.profile.cart.numberOfItems = 0;
        this.profile.cart.totalPrice = 0;

        this.profile.cart.items.forEach(element => {
            this.profile.cart.numberOfItems = +(this.profile.cart.numberOfItems + element.purchaseQuantity);

            if (element.id && element) {
                this.profile.cart.totalPrice = +(this.profile.cart.totalPrice + (element.purchaseQuantity * element.pricePerUnit)).toFixed(2);
            }
        });
    }

    removeProductFromCart(productId) {

        for (let i = 0; i < this.profile.cart.items.length; i++) {
            if (this.profile.cart.items[i].id == productId) {
                this.profile.cart.items.splice(i, 1);
                break;
            }
        }
        this.updateCart();
    }

    updateProductQuantity(productId, quan) {

        for (let i = 0; i < this.profile.cart.items.length; i++) {
            if (this.profile.cart.items[i].id == productId) {
                this.profile.cart.items[i].purchaseQuantity = quan;
                break;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/services/profile-storage.service.ts